import React from "react";
import { useInstantSearch } from "react-instantsearch";
import ExpertSkeletonPage from "./expert_skeleton_page";

function SearchLoadingCards() {
  const { results } = useInstantSearch();

  const isLoading = !results;

  if (!isLoading) return null;

  return <ExpertSkeletonPage numberOfCards={12} />;
}

export default SearchLoadingCards;
